import React, { Fragment } from 'react';
import { Show, TextField, DateField, ArrayField, Datagrid } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import { AmountField, LinkField, JsonTextField } from 'cw-core-admin-ui/src/components/fields';
import { Grid, GridShowLayout } from 'cw-core-admin-ui/src/components/wrapper';

export const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20,
	},
	show: {
		marginBottom: 24,
	},
	list: {
		marginBottom: 24,
	},
});

export default (props) => {
	const classes = useStyles();
	return (
		<Fragment>
			<Show {...props} className={classes.show}>
				<GridShowLayout>
					<Grid container spacing={2}>
						<Grid item xs={12} md>
							<TextField source="id" />
							<TextField source="displayId" />
							<DateField source="creationDateTime" showTime />
							<LinkField source="marketplaceId" type="Marketplace" />
							<TextField source="purchaseType" />
							<TextField source="purchaseStatus" />
							<AmountField source="amount" />
							<TextField source="description" />
							<TextField source="customType" />
							<TextField source="purchaseSettlementStatus" />
							<TextField source="manualSettlementComment" />
						</Grid>
						<Grid item xs={12} md>
							<LinkField source="consumerWalletAccountId" type="WalletAccount" />
							<LinkField source="consumerWalletId" type="Wallet" />
							<AmountField source="consumerAmount" />
							<Grid container>
								<Grid xs={6}>
									<TextField source="firstName" />
								</Grid>
								<Grid xs={6}>
									<TextField source="lastName" />
								</Grid>
							</Grid>
							<TextField source="emailAddress" />
							<JsonTextField source="billingAddress" fullWidth />
							<JsonTextField source="shippingAddress" fullWidth />
							<ArrayField source="sellers" fieldKey="sellerId">
								<Datagrid>
									<LinkField source="sellerId" type="MarketplaceSeller" />
									<AmountField source="amount" />
								</Datagrid>
							</ArrayField>
						</Grid>
					</Grid>
					<TextField source="redirectUrl" />
				</GridShowLayout>
			</Show>
		</Fragment>
	);
};
